"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckoutHelp = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const svg_1 = require("@obvio/svg");
const ui_1 = require("@obvio/ui");
const components_1 = require("./components");
function OptionalLink({ href, children, }) {
    if (!href) {
        return null;
    }
    return (0, jsx_runtime_1.jsx)(app_1.Link, Object.assign({ href: href }, { children: children }));
}
function CheckoutHelp({ mail }) {
    const { t } = (0, app_1.useTranslation)();
    const privacyPolicyPath = (0, app_1.useContextPath)('privacyPolicy');
    const tosPath = (0, app_1.useContextPath)('tos');
    const rodoPath = (0, app_1.useContextPath)('rodo');
    return ((0, jsx_runtime_1.jsxs)(components_1.HelpStack, Object.assign({ kind: "vertical", divider: true, spacing: "extraSmall" }, { children: [(0, jsx_runtime_1.jsxs)(ui_1.Stack, Object.assign({ spacing: "extraSmall" }, { children: [(0, jsx_runtime_1.jsx)(svg_1.SvgInfo, {}), (0, jsx_runtime_1.jsxs)(app_1.Text, Object.assign({ tag: "span" }, { children: [t('info.needHelp'), ' ', (0, jsx_runtime_1.jsx)(app_1.Link, Object.assign({ href: `mailto:${mail}` }, { children: t('info.contactUs') }))] }))] })), (0, jsx_runtime_1.jsxs)(ui_1.Stack, Object.assign({ spacing: "small" }, { children: [(0, jsx_runtime_1.jsx)(OptionalLink, Object.assign({ href: privacyPolicyPath }, { children: t('info.PrivacyPolicy') })), (0, jsx_runtime_1.jsx)(OptionalLink, Object.assign({ href: tosPath }, { children: t('info.termsOfService') })), (0, jsx_runtime_1.jsx)(OptionalLink, Object.assign({ href: rodoPath }, { children: t('info.gdpr') }))] }))] })));
}
exports.CheckoutHelp = CheckoutHelp;
